const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`, `351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`, 1, 19), new Map([[`reverse_markup`, true]]), false, false, 1));
            }

            getTemplateName() {
                return `351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`, ``);
            }
        }],
        [19, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/media/media.twig`, `351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`, 1);

                this.blocks = new Map([
                    ['object', [this, 'block_object']],
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/media/media.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_object(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    `);
                this.echo(this.include(context, this.source, `@cloudfour/components/calendar-date/calendar-date.twig`, new Map([[`datetime`, `2020-08-17`], [`note`, `3-day event`]]), false, false, 5));
                this.echo(`  `);
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <h3>An Event Apart</h3>
    <p>Minneapolis, MN</p>
    <p>Speaker: Jason</p>
  `);
            }

            getTemplateName() {
                return `351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8');

let template = env.loadTemplate('351a99c267ec28f2cfc6327fb696842b06d8c0ed433933711a217ce9351c84d8');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/media/demo/calendar-date.twig", args: context }
     );
     return rendered;;
};